import { PreferencesFirestorePersistenceContext } from "~applications";
import { createStaticContextProvider, lazyValue } from "~utils";

export const PreferencesPersistenceProvider = createStaticContextProvider(
  PreferencesFirestorePersistenceContext,
  lazyValue(() =>
    import("./preferences-persistence").then(
      (module) => module.preferencesPersistence,
    ),
  ),
);
